<template>
    <!-- trade bottom start -->
    <div class="trade-bottom-nav">
      <ul >
        <!-- <li><a href="javascript:;" class="b-nav1" :class="currentPageBottom=='itemList'?'active':''"  @click="onClickGoBtn(1)">관심종목</a></li> -->
        <li><router-link :to="{ name: ''}" class="b-nav1" :class="currentPageBottom=='itemList'?'active':''"  @click="onClickGoBtn(1)">종목검색</router-link></li>
        <li><router-link :to="{ name: ''}" class="b-nav2" :class="currentPageBottom=='orderbook'?'active':''" @click="onClickGoBtn(2)">호가창 </router-link></li>
        <li><router-link :to="{ name: ''}" class="b-nav3" :class="currentPageBottom=='tradeChart'?'active':''" @click="onClickGoBtn(3)">차트</router-link></li>
        <li><router-link :to="{ name: ''}" class="b-nav4" :class="currentPageBottom=='tradeArea'?'active':''" @click="onClickGoBtn(4)">주문</router-link></li>
        <li><router-link :to="{ name: ''}" class="b-nav5" :class="currentPageBottom=='tradeResult'?'active':''"  @click="onClickGoBtn(5)">보유종목</router-link></li>
        <li><router-link :to="{ name: ''}" class="b-nav6" :class="currentPageBottom=='liveBroadcast'?'active':''" @click="onClickGoBtn(6)">라이브</router-link></li>
      </ul>
    </div>
    <!-- // trade bottom end -->
</template>

<script>
//import Config from '../../public/config.js';
// import axios from '@/axios';
 import { useStore } from 'vuex';
 import { useRouter }from 'vue-router'
 import {computed, getCurrentInstance } from 'vue'
 //import VueCookies from "vue-cookies";
export default {
  props:{
    id:{
          type:String,         
          required:true
       }
  },
  
  setup(props){
    
    //const cootoken = ref(VueCookies.get('cootoken'));
  
    console.log("TradeBottomNav", props.id)
    const router = useRouter();
    const store = useStore();
    const isLogin = computed(() => store.state.user.isLogin);
    const currentTradeType = computed(() => store.state.hts.currentTradeType);
    const currentPageBottom = computed(() => store.state.trade.currentPageBottom);
    const emitter = getCurrentInstance().appContext.config.globalProperties.emitter;

    const goLoginPage=()=>{
      //location.href = Config.URL.flexLifeUrl + `login?app=money&redirect_url=${Config.URL.flexMoneyUrl}`;\
      location.href = process.env.VUE_APP_flexTvUrl + `partner/money/signin?&callbackUrl=${process.env.VUE_APP_flexMoneyUrl}`;
    }
    const onClickGoBtn = (_type) =>{
     var _item = JSON.parse(sessionStorage.getItem(`startItem_${currentTradeType.value}`))
     console.log("bottom:", _item )
     switch(_type)
     {
       case 1:    
          var goName = null;
          if(currentTradeType.value == 'C')
          {
            goName = 'ItemListCoin'; 
          }
          else if(currentTradeType.value == 'S')
          {
            goName = 'ItemListStock';
          }
          else if(currentTradeType.value == 'F')
          {
            goName = 'ItemListFutures';
          }
          else if(currentTradeType.value == 'G')
          {
            goName = 'ItemListCoinFutures';
          }
          router.push({
              name: goName,   
              params: {
                id:props.id,               
              }          
          }) 

       
        break; 
       case 2:

          router.push({
              name: 'OrderBook',
              params: {
                code:_item.CODE,  
                id:props.id,             
              }
           }) 

        break;
       case 3:

           _item = JSON.parse(sessionStorage.getItem(`startItem_${currentTradeType.value}`))
           router.push({
              name: 'TradeChart',
              params: {
                code:_item.CODE, 
                id:props.id,               
              }
           }) 
        break;
       case 4:
            if(!isLogin.value)
            {
              emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
              return;
            }
           _item = JSON.parse(sessionStorage.getItem(`startItem_${currentTradeType.value}`))
          router.push({
              name: 'TradeArea',
              params: {
                  code:_item.CODE,  
                  id:props.id,              
              }
          }) 




        break;
       case 5:
            if(!isLogin.value)
            {
              emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
              return;
            }
           _item = JSON.parse(sessionStorage.getItem(`startItem_${currentTradeType.value}`))

            var goNameRe = null;
            if(currentTradeType.value == 'G')
            {
               goNameRe = 'TradeResultCF'; 
            }
            else
            {
               goNameRe = 'TradeResult'; 
            }

           router.push({
              name: goNameRe,     
               params: {
                  code:_item.CODE,
                  id:props.id,                
              }         
           }) 

        break;
       case 6:
            if(!isLogin.value)
            {
              emitter.emit('EVENT_ALERT',{title:"알림", body:"로그인 후 사용가능합니다.", fn:goLoginPage});
              return;
            }
            router.push({
              name: 'LiveBroadcast',
              params: {                  
                  id:props.id,                
              } 
            }) 
           //console.log("cootoken", cootoken.value)
          //  window.open('about:blank').location.href = `https://www.flextv.co.kr/redirects/signin?token=${cootoken.value}&redirectTo=/`

        break;
     }
   }



    return {
     
      onClickGoBtn,
      currentPageBottom
    }
  }
}
</script>

<style>

</style>